// import PersonOccupationSelector from 'components/common/PersonOccupationSelector';
import React from 'react';
import FormWrapper from './FormWrapper';
import TitleSelector from 'components/TitleSelector';

const PersonTitleSelector = (props) => {
    const {
        formik,
        i18n,
        index,
        name,
        label,
        title,
        required = false,
        disabled,
        readOnly,
        helper,
    } = props;
    const value = formik.values[name];
    return (
        <FormWrapper {...props}>
            <TitleSelector
                value={value}
                onChangeValue={(value) => {
                    formik.setFieldValue(name, value);
                }}
                isDisabled={disabled}
            />
        </FormWrapper>
    );
};

// export default PersonTitleSelector;

export default React.memo(PersonTitleSelector, (prev, next) => {
    const name = prev.name;
    return (
        prev.formik.values[name] === next.formik.values[name] &&
        prev.formik.errors[name] === next.formik.errors[name] &&
        prev.formik.touched[name] === next.formik.touched[name] &&
        prev.disabled === next.disabled &&
        prev.i18n === next.i18n
    );
});

